const CURRENT_USER_KEY = 'cop:current-user'
const COUNTRY_SELECTOR_SELECTOR = '.cmp-header__country-selector'

function isGraniteAuthor(): boolean {
    return Boolean((window as unknown as { Granite?: { author?: unknown } }).Granite?.author)
}

function isCopUser(): boolean {
    try {
        return Boolean(JSON.parse(sessionStorage.getItem(CURRENT_USER_KEY) || 'null'))
    } catch {
        return false
    }
}

function revealCountrySelector(): void {
    document.querySelectorAll<HTMLElement>(COUNTRY_SELECTOR_SELECTOR).forEach(el => {
        el.style.visibility = 'visible'
    })
}

function hideCountrySelectorForNonCopUsers(): void {
    if (isCopUser()) {
        revealCountrySelector()
        return
    }

    document.querySelectorAll<HTMLElement>(COUNTRY_SELECTOR_SELECTOR).forEach(el => {
        el.style.display = 'none'
    })
}

function init(): void {
    // Author mode: keep the selector visible so editors can see and edit it.
    if (isGraniteAuthor()) {
        revealCountrySelector()
        return
    }
    // Scoped to Power Portal only — the country selector must stay visible on the public site
    if (!document.body.classList.contains('cmp-powerportal-main')) {
        revealCountrySelector()
        return
    }
    hideCountrySelectorForNonCopUsers()
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
} else {
    init()
}
